import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import Banners from 'modules/expenses/components/expenses/PageContents/_Banners'

const Content = ({ children }: React.PropsWithChildren) => {
  return (
    <Box flexDirection="column" height="full" flexGrow paddingTop="s16" style={{ minHeight: '0' }}>
      <Banners />
      <Box flexGrow style={{ minHeight: '0' }}>
        {children}
      </Box>
    </Box>
  )
}

export default Content
